import i18n from "@microdoing/shared/i18n";

export const pluralizeI18n = (slug: string, count: number) =>
  i18n.t(`${slug}${count > 1 ? "_plural" : ""}`);

export const pluralize = (string: string, count: number) =>
  `${string}${count > 1 ? "s" : ""}`;
